<template>
  <section class="container">
    <h1 class="mb-1e is-size-3">Generowanie kart</h1>

    <div v-if="Object.keys(allSorted).length">
      <div class="settings">
        <div class="field">
          <template v-if="isRange">
            <label class="label mb-0">Wybierz zakres do druku (początkową i ostatnią kartę):</label>
            <a
              href="#"
              class="d-block is-size-7"
              @click.prevent="isRange = false"
              >
              Kliknij, by wybrać pojedyncze karty
            </a>

            <div class="field has-addons mt-3">
              <div class="control">
                <div class="select">
                  <select v-model="selectedMin">
                    <option value="null" disabled selected>Wybierz początkową kartę</option>
                    <option
                      v-for="(card, key) in allSorted"
                      :key="key"
                      :value="key"
                      v-html="`${card.id} - ${card.name || ''}`">
                    </option>
                  </select>
                </div>
              </div>
              <div class="control">
                <div class="select">
                  <select v-model="selectedMax">
                    <option value="null" disabled selected>Wybierz ostatnią kartę</option>
                    <option
                      v-for="(card, key) in allSorted"
                      :key="key"
                      :value="key"
                      v-html="`${card.id} - ${card.name || ''}`">
                    </option>
                  </select>
                </div>
              </div>
              <div class="control">
                <button type="button" class="button is-info" @click.prevent="generateSubset">
                  Generuj
                </button>
              </div>
            </div>
          </template>
          <template v-else>
            <label class="label mb-0">Wybierz pojedyncze karty:</label>
            <a
              href="#"
              class="d-block is-size-7"
              @click.prevent="isRange = true"
              >
              Kliknij, by wybrać zakres
            </a>

            <div class="field mt-3">
              <v-select
                v-model="filteredKeys"
                :options="allSortedArray"
                :reduce="obj => obj.key"
                :closeOnSelect="false"
                :multiple="true"
                label="name"
              />
            </div>
          </template>
        </div>

        <div>
          <label class="checkbox">
            <input type="checkbox" v-model="showNv">
            Dodaj ramki "Nie odwiedzać"
          </label>
        </div>
        <div>
          <label class="checkbox">
            <input type="checkbox" v-model="isAdditional">
            Wyświetl na karcie dodatkowe informacje
          </label>
        </div>
        <div>
          <label class="checkbox">
            <input type="checkbox" v-model="noRotate">
            Nie odwracaj kart (również dla druku)
          </label>
        </div>
        <div>
          <label class="checkbox">
            <input type="checkbox" v-model="hasMarks">
            Znaczniki do wycinania
          </label>
        </div>
      </div>

      <div
        class="card-wrap"
        :class="{ 'cards--no-rotate': noRotate }"
        v-for="(card, index) in filtered"
        :key="`card-${index}`">

        <Card
          :territory="card"
          :isAdditional="isAdditional"
          :hasMarks="hasMarks"
        />

        <NotVisitGroup
          v-if="showNv"
          :group="grouped[card.key]"
          :print="true"
        />
      </div>
    </div>

    <article class="message is-info" v-else>
      <div class="message-header">
        <p>Nie dodano jeszcze żadnych kart terenów.</p>
      </div>
    </article>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import Card from '@/components/Card.vue';
import NotVisitGroup from '@/components/NotVisitGroup.vue';
import { getSortedListByKeys } from '../utils';

export default {
  data: () => ({
    isAdditional: false,
    filteredKeys: [],
    hasMarks: false,
    isRange: true,
    noRotate: false,
    selectedMin: null,
    selectedMax: null,
    showNv: true,
  }),
  components: {
    Card,
    NotVisitGroup,
  },
  computed: {
    ...mapGetters({
      all: 'allTerritories',
      grouped: 'GROUPED_NVS',
    }),
    allSorted() {
      return getSortedListByKeys(this.all, Object.keys(this.all));
    },
    allSortedArray() {
      return Object.keys(this.allSorted).map(key => ({
        key,
        name: `${this.allSorted[key]?.id} - ${this.allSorted[key]?.name || ''}`,
      }));
    },
    filtered() {
      return getSortedListByKeys(this.all, this.filteredKeys);
    },
  },
  methods: {
    countSubset() {
      if (this.selectedMin !== null && this.selectedMax !== null) {
        const onlyKeys = Object.keys(this.allSorted);
        const indexMin = onlyKeys.indexOf(this.selectedMin);
        const indexMax = onlyKeys.indexOf(this.selectedMax) + 1;
        const slicedKeys = onlyKeys.slice(indexMin, indexMax);

        if (slicedKeys.length) {
          return slicedKeys;
        }
      }

      return [];
    },
    generateSubset() {
      this.filteredKeys = this.countSubset();
    },
  },
};
</script>

<style lang="scss">
.vs__dropdown-option.vs__dropdown-option--selected {
  color: #999;
}
</style>

<style lang="scss" scoped>
.field {
  width: 60rem;
  max-width: 100rem;

  > .control {
    width: 33.33%;
  }

  .select,
  select {
    width: 100%;
  }
}

.label {
  margin-bottom: .5rem;
}

@media print {
  h1,
  .settings {
    display: none;
  }

  .card-wrap {
    page-break-before: always;
  }
}
</style>
